import type {RuleValidationErrors} from '../types';
import type {UserRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateUserRule = <T extends UserRule = UserRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (typeof rule.elementValue1 !== 'number' || rule.elementValue1 < 1) {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateUserRule;
